var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'empty')?[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-pic"},[_c('img',{attrs:{"src":require("@/assets/svg/illustrations/loading.svg")}})]),_c('p',[_vm._v("Loading...")])])]:_vm._l((_vm.lines),function(line){return _c('div',{key:line,staticClass:"skeleton",class:[
        {'last-line': _vm.lines !== 1 && _vm.lines === line - 1},
        {'animated-loading': _vm.animated },
        {'rounded-corners': _vm.roundedCorners },
        _vm.type
      ]})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }